"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;

var tslib_1 = require("tslib");

var ui_field_label_1 = require("@hopin-team/ui-field-label");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_menu_1 = require("@hopin-team/ui-menu");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importDefault(require("react"));

var clear_button_1 = require("./styled/clear-button");

var input_1 = require("./styled/input");

var search_button_1 = require("./styled/search-button");

var Search = function Search(_a) {
  var __UIScope = _a.__UIScope,
      ariaLabel = _a["aria-label"],
      testID = _a["data-testid"],
      className = _a.className,
      id = _a.id,
      isShowingSuggestions = _a.isShowingSuggestions,
      label = _a.label,
      onChange = _a.onChange,
      onClear = _a.onClear,
      onSubmit = _a.onSubmit,
      onClose = _a.onClose,
      placeholder = _a.placeholder,
      _b = _a.colorPattern,
      colorPattern = _b === void 0 ? 'dark' : _b,
      _c = _a.sizeOption,
      sizeOption = _c === void 0 ? 'small' : _c,
      suggestions = _a.suggestions,
      value = _a.value,
      props = tslib_1.__rest(_a, ["__UIScope", 'aria-label', 'data-testid', "className", "id", "isShowingSuggestions", "label", "onChange", "onClear", "onSubmit", "onClose", "placeholder", "colorPattern", "sizeOption", "suggestions", "value"]);

  var _d = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Search',
    className: className,
    __UIScope: __UIScope
  }),
      makeClasses = _d.makeClasses,
      rootClasses = _d.rootClasses;

  var fieldId = (0, use_id_1.useId)(id);
  var a11yProps = {};

  if (label || isShowingSuggestions) {
    a11yProps.id = fieldId;
  } else {
    a11yProps['aria-label'] = ariaLabel;
  }

  var _e = tslib_1.__read((0, ui_helper_hooks_1.useOnKeyPress)('Enter', onSubmit), 1),
      inputRef = _e[0];

  return react_1.default.createElement(react_1.default.Fragment, null, label && react_1.default.createElement(ui_field_label_1.FieldLabel, {
    className: makeClasses('Label'),
    fieldId: fieldId,
    label: label,
    mb: 0.5
  }), react_1.default.createElement(ui_menu_1.Menu, {
    className: rootClasses,
    "data-testid": testID,
    isShowing: isShowingSuggestions,
    isDismissible: true,
    onClose: onClose
  }, react_1.default.createElement(ui_flex_1.Flex, null, react_1.default.createElement(input_1.Input, tslib_1.__assign({
    className: makeClasses('Input'),
    type: "search",
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    colorPattern: colorPattern,
    sizeOption: sizeOption
  }, a11yProps, props, {
    ref: inputRef
  })), react_1.default.createElement(search_button_1.SearchButton, {
    className: makeClasses('Submit'),
    type: "submit",
    icon: "search",
    title: "Submit search query",
    onClick: onSubmit,
    size: "tiny",
    sizeOption: sizeOption,
    colorPattern: colorPattern,
    isGhost: true
  }), react_1.default.createElement(clear_button_1.ClearButton, {
    className: makeClasses('Clear'),
    type: "reset",
    icon: "close-circle",
    title: "Clear search query",
    onClick: onClear,
    sizeOption: sizeOption,
    disabled: !value,
    isGhost: true
  })), isShowingSuggestions && suggestions && react_1.default.createElement(ui_menu_1.MenuContent, {
    mt: 0
  }, react_1.default.createElement(ui_menu_1.MenuSelect, {
    labelledById: fieldId,
    role: "listbox",
    mx: 1.5,
    my: 1
  }, suggestions.map(function (suggestion, i) {
    return react_1.default.createElement(ui_menu_1.MenuSelectItem, {
      key: i,
      label: suggestion,
      role: "option",
      p: 0.5
    });
  })))));
};

var SearchWithSpace = (0, ui_helper_with_space_1.withSpace)(Search);
exports.Search = SearchWithSpace;